module.exports = __webpack_public_path__ + "img/ic_r_json.0df3a428.png";